import React, { useState } from "react";
import Header from "./header";
import NavBar from "./navBarContainer";

const treasuryData = {
  treasuryDetails: [
    {
      investedProjects: "-",
      amount: "-",
      return: "-",
      date: "-",
    },
    // {
    //   investedProjects: "King",
    //   amount: "14 : 10 : 20",
    //   return: "25864578.065",
    //   date: "14 : 10 : 20",
    // },
    // {
    //   investedProjects: "King",
    //   amount: "14 : 10 : 20",
    //   return: "25864578.065",
    //   date: "14 : 10 : 20",
    // },
    // {
    //   investedProjects: "King",
    //   amount: "14 : 10 : 20",
    //   return: "25864578.065",
    //   date: "14 : 10 : 20",
    // },
  ],
};

export default function Backend() {
  const [treasuryDetails, setTreasuryDetails] = useState(
    treasuryData.treasuryDetails
  );

  return (
    <div className="sidemenu">
      <div className="wrapper">
        <NavBar />
        <div className="dash-treasury">
          <div id="content">
            <div className="toogle-button">
              <button type="button" id="sidebarCollapse" className="btn ">
                <i className="fas fa-arrow-left" aria-hidden="true"></i>
              </button>
            </div>
            <Header />
            <div className="second-section mt-2">
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="table-values">
                    <table className="table table-borderless ">
                      <thead>
                        <tr>
                          <th>Invested projects</th>
                          <th>Amount</th>
                          <th>Return</th>
                          <th>Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {treasuryDetails.map((treasury) => {
                          return (
                            <tr>
                              <td>{treasury.investedProjects}</td>
                              <td>{treasury.amount}</td>
                              <td>{treasury.return}</td>
                              <td>{treasury.date}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
